import { useEffect, useState } from 'react';
import { Maybe, QuestionItem } from '__generated__/graphql';
import { DeckButtonContainer } from './Deck/DeckButtonContainer';

type QuestionCardProps = {
  question: Maybe<QuestionItem>;
  onAnswer: (value: boolean) => void;
  isTransitioning?: boolean;
};

export default function QuestionCard({ question, onAnswer, isTransitioning = false }: QuestionCardProps) {
  const { id, title, pic } = question || {};
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (isTransitioning) {
      setIsVisible(false);
    } else {
      // Reset visibility when new question loads
      setIsVisible(true);
    }
  }, [isTransitioning, id]);

  const handleClick = (dir: string) => {
    onAnswer(dir === 'right');
  };

  const imageUrl = pic ? `${process.env.REACT_APP_CLOUDFRONT_URL}${pic}` : null;

  return (
    <div className="flex flex-col items-center">
      <div className="grid mt-4">
        <div className="col-start-1 row-start-1" key={id || 'unknown'}>
          <div className="h-full text-center text-white break-words bg-primary-600 max-w-72 ">
            <div className="relative">
              <DeckButtonContainer onClickButton={handleClick}>
                {imageUrl ? (
                  <img
                    key={pic}
                    src={imageUrl}
                    draggable="false"
                    onDragStart={(e) => e.preventDefault()}
                    alt={`${id}: ${title}`}
                    className={`w-full h-auto rounded-md transition-opacity duration-300 ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}
                  />
                ) : (
                  <div className="w-full" style={{ minHeight: '200px' }} />
                )}
              </DeckButtonContainer>
            </div>
            <div
              className={`min-h-[4rem] sm:min-h-[6rem] text-base sm:text-lg mt-2 sm:mt-3 transition-opacity duration-300 ease-in-out ${
                isVisible ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <h1>{title}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
